"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLocationString = parseLocationString;
exports.createLocationString = createLocationString;
exports.joinLocationStringPaths = joinLocationStringPaths;
exports.buildOwnedBlobLocation = buildOwnedBlobLocation;
function parseLocationString(location, optionalSource = false) {
    const matches = /^(?<source>.+?):(?<path>.*)$/.exec(location);
    if (matches === null) {
        if (optionalSource) {
            return {
                source: null,
                path: location,
            };
        }
        throw new Error("Location paths must be in 'source:path' format.");
    }
    return {
        source: matches.groups['source'],
        path: matches.groups['path'],
    };
}
function createLocationString(source, path1, ...paths) {
    return `${source}:${[path1, ...paths].join('/')}`;
}
function joinLocationStringPaths(location, ...paths) {
    const { source, path } = parseLocationString(location);
    return createLocationString(source, path, ...paths);
}
function buildOwnedBlobLocation(ownedLocationSource, ownerId, relativePath) {
    return createLocationString(ownedLocationSource, `${ownerId}/${relativePath}`);
}
//# sourceMappingURL=ServiceLocation.js.map